import { Box } from "@mui/material";
import styled from "styled-components";

export const StyledContainer = styled(Box)(
    ({ theme }) => `
    .activeHighlight {
        background-color: ${theme.uptimeColors.newsKnowledgeColors.highlight[0]};
      }
  `
);